import { render, staticRenderFns } from "./SubscriptionsTable.vue?vue&type=template&id=8513ca3e&scoped=true&"
import script from "./SubscriptionsTable.vue?vue&type=script&lang=ts&"
export * from "./SubscriptionsTable.vue?vue&type=script&lang=ts&"
import style0 from "./SubscriptionsTable.vue?vue&type=style&index=0&id=8513ca3e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8513ca3e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/builds/intern/customer-portal/frontend/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib'
installComponents(component, {VDataTable})
